module.exports = __webpack_public_path__ + "img/semoule.9ee83dff.png";